import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bot, Plug, BookOpen, KeyRound, ChevronRight, Package, Send, CheckSquare, Bell, Sparkles, ScrollText, Trash2, MessageSquare, Compass, Heart } from 'lucide-react';
import { haptic } from '../../telegram';
import { useTour } from '../components/Tour';

type Tile = { to: string; icon: any; label: string; sub: string };
type Group = { title: string; tiles: Tile[] };

// Порядок групп: сверху рабочее, внизу — помощь, правовое и опасная зона.
const GROUPS: Group[] = [
  {
    title: 'Команда и интеграции',
    tiles: [
      { to: '/settings/agents', icon: Bot, label: 'Агенты', sub: 'AI-рабочие, которые выполняют задачи' },
      { to: '/settings/connections', icon: Plug, label: 'Связи', sub: 'MCP-серверы, вебхуки и интеграции' },
      { to: '/settings/knowledge', icon: BookOpen, label: 'База знаний', sub: 'Документы и память агентов' },
    ],
  },
  {
    title: 'Модель и поведение',
    tiles: [
      { to: '/settings/byok', icon: KeyRound, label: 'API-ключи', sub: 'Свои модели LLM (BYOK) и провайдеры' },
    ],
  },
  {
    title: 'Автоматизация по времени',
    tiles: [
      { to: '/settings/tasks', icon: CheckSquare, label: 'Задачи', sub: 'Действия по расписанию' },
      { to: '/settings/reminders', icon: Bell, label: 'Напоминания', sub: 'Сообщение в нужное время' },
    ],
  },
  {
    title: 'Маркетплейс',
    tiles: [
      { to: '/marketplace/mine', icon: Package, label: 'Мои публикации', sub: 'Листинги и установленное' },
      { to: '__soon__', icon: Send, label: 'Опубликовать', sub: 'Поделиться своим сценарием — пока в разработке' },
    ],
  },
  {
    title: 'Обучение и помощь',
    tiles: [
      { to: '__tour__', icon: Compass, label: 'Знакомство с платформой', sub: 'Короткий тур по экранам — что и где находится' },
      { to: '/settings/feedback', icon: MessageSquare, label: 'Оставить отзыв', sub: 'Идеи, баги и пожелания — напрямую команде' },
      { to: '/settings/changelog', icon: Sparkles, label: 'Что нового', sub: 'История обновлений и исправлений' },
      { to: '/settings/support', icon: Heart, label: 'Поддержать проект', sub: 'Добровольная поддержка Telegram Звёздами' },
    ],
  },
  {
    title: 'Правовая информация',
    tiles: [
      { to: '/settings/legal', icon: ScrollText, label: 'Документы', sub: 'Условия, конфиденциальность, дисклеймер' },
    ],
  },
  {
    title: 'Опасная зона',
    tiles: [
      { to: '/settings/account', icon: Trash2, label: 'Удалить аккаунт', sub: 'Удаление аккаунта и всех данных' },
    ],
  },
];

export function Settings() {
  const nav = useNavigate();
  const { start } = useTour();
  // '__soon__' — пункт виден, но никуда не ведёт: функция ещё не реализована.
  const onTile = (to: string) => { haptic('light'); if (to === '__soon__') return; if (to === '__tour__') start(); else nav(to); };
  return (
    <div className="rf-page">
      <div className="rf-in">
        <div className="rf-ptitle">Настройки</div>
        <div className="rf-psub">Управление агентами, связями, моделями и расписанием</div>
      </div>

      <div className="rf-info rf-in"><Sparkles /><div>Всё для настройки вашей ИИ-команды собрано здесь. Выберите раздел, чтобы начать.</div></div>

      {GROUPS.map((g) => (
        <div key={g.title} className="rf-set-group rf-in">
          <div className="rf-seclabel">{g.title}</div>
          <div className="rf-rows">
            {g.tiles.map((t) => {
              const Icon = t.icon;
              return (
                <div key={t.to} data-tour={t.to} className="rf-card rf-row" onClick={() => onTile(t.to)}>
                  <div className="rf-row-ic"><Icon /></div>
                  <div className="rf-row-body">
                    <div className="rf-row-title">{t.label}</div>
                    <div className="rf-row-meta"><span>{t.sub}</span></div>
                  </div>
                  <div className="rf-row-right"><ChevronRight /></div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
